import React from 'react';
import { Box, useTheme, useMediaQuery } from '@mui/material';
import { useLocation } from 'react-router-dom';
import TopAppBar from './TopAppBar';
import MobileBottomNav from './MobileBottomNav';
import { FIELD_BLACK } from '../../design/stoneTokens';
import { isIsolatedSurface } from '../../utils/routeSurfaces';

export const StoneLayout = ({ children }) => {
  const theme = useTheme();
  const location = useLocation();
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));

  const isIsolatedRoute = isIsolatedSurface(location.pathname);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        backgroundColor: FIELD_BLACK,
        color: 'text.primary',
        position: 'relative',
        overflowX: 'hidden',
      }}
    >
      {/* Desktop Navigation */}
      {isDesktop && !isIsolatedRoute && <TopAppBar />}

      {/* Main Content Area */}
      <Box
        component="main"
        id="main-content"
        sx={{
          flexGrow: 1,
          width: '100%',
          maxWidth: '100%',
          minWidth: 0,
          pt: isIsolatedRoute ? 0 : (isDesktop ? '80px' : 0),
          pb: isIsolatedRoute ? 0 : (isDesktop ? '24px' : '100px'), // Space for MobileBottomNav
          // The theme uses a 16px spacing unit; use explicit values so the
          // phone shell stays at the intended 8px per side.
          px: isIsolatedRoute ? 0 : { xs: '8px', sm: '16px', md: '64px', lg: '96px' },
          transition: 'padding 0.3s ease',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        {children}
      </Box>

      {/* Mobile Navigation */}
      {!isDesktop && !isIsolatedRoute && <MobileBottomNav />}
    </Box>
  );
};

export default StoneLayout;
